import { render, staticRenderFns } from "./DialogDeletePost.vue?vue&type=template&id=1e4c1942&"
import script from "./DialogDeletePost.vue?vue&type=script&lang=js&"
export * from "./DialogDeletePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports